import { Box } from '@customerio/pluma-components/react';

/** Entry step (email + Google signup). Placeholder — content lands with FPS-2857. */
export function IndexStep() {
  return <Box data-testid="signup-step-index" />;
}
